module.exports = __webpack_public_path__ + "static/media/h4.271a4bb4.svg";